import { defineMessages } from '@dragonraider5/react-intl'
import * as codes from 'inbonis-exception/lib/index'
import * as internalCodes from './constants'

export default defineMessages({
  // Application lvl errors
  [internalCodes.CLIENT]: {
    id: 'utils.exceptions.messages.CLIENT',
    description: 'Default message for application error',
    defaultMessage:
      `Lo sentimos ha ocurrido un error en la aplicación.
       Por favor intentelo de nuevo más tarde.
       Si el problema persiste no dudes en contactar con nosotros.`
  },
  [internalCodes.SERVICE_UNAVAILABLE]: {
    id: 'utils.exceptions.messages.SERVICE_UNAVAILALBE',
    description: 'Default message for api service unavailable',
    defaultMessage:
      `Lo sentimos el servicio no está disponible en estos momentos.
       Por favor intentelo de nuevo más tarde.
       Si el problema persiste no dudes en contactar con nosotros.`
  },
  // Common api errors
  [codes.AXIOS_ERROR]: {
    id: 'utils.exceptions.api.messages.AXIOS_ERROR',
    description: 'Default message for api error AXIOS_ERROR',
    defaultMessage:
      `Lo sentimos el servicio no está disponible en estos momentos.
      Por favor intentelo de nuevo más tarde.
      Si el problema persiste no dudes en contactar con nosotros.`
  },
  // Authorization api errors
  [codes.AUTHORIZATION_BAD_HEADER]: {
    id: 'utils.exceptions.api.messages.AUTHORIZATION_BAD_HEADER',
    description: 'Default message for api error AUTHORIZATION_BAD_HEADER',
    defaultMessage: 'Lo sentimos no hemos podido autorizar tu usuario en el servidor.'
  },
  [codes.AUTHORIZATION_JWT_ERROR]: {
    id: 'utils.exceptions.api.messages.AUTHORIZATION_JWT_ERROR',
    description: 'Default message for api error AUTHORIZATION_JWT_ERROR',
    defaultMessage: 'Lo sentimos no hemos podido autorizar tu usuario en el servidor.'
  },
  // user
  [codes.USER_ALREADY_EXISTS]: {
    id: 'utils.exceptions.api.messages.USER_ALREADY_EXISTS',
    description: 'Default message for api error USER_ALREADY_EXISTS',
    defaultMessage:
      `Lo sentimos, el e-mail introducido ya ha sido registrado en nuestra plataforma.
       Si tienes usuario puedes iniciar sesión para continuar con tu solicitud.`
  },
  [codes.USER_NOT_FOUND]: {
    id: 'utils.exceptions.api.messages.USER_NOT_FOUND',
    description: 'Default message for api error USER_NOT_FOUND',
    defaultMessage:
      `Lo sentimos, el e-mail o la contraseña son incorrectos.`
  },
  [codes.USER_NOT_ACTIVE]: {
    id: 'utils.exceptions.api.messages.USER_NOT_ACTIVE',
    description: 'Default message for api error USER_NOT_ACTIVE',
    defaultMessage:
      `El email del usuario no ha sido verificado, por favor revisa tu bandeja
       de entrada y siga las instrucciones del correo electrónico para activar la cuenta.`
  },
  [codes.USER_PASSWORD_TOKEN_VALIDATION]: {
    id: 'utils.exceptions.api.messages.USER_PASSWORD_TOKEN_VALIDATION',
    description: 'Default message for api error USER_PASSWORD_TOKEN_VALIDATION',
    defaultMessage:
      `La solicitud de reestablecer contraseña es invalida o ha expirado. Por favor asegúrate que la url introducida es
       tal como aparece en el correo electrónico.`
  },
  [codes.USER_ACTIVATION_TOKEN_VALIDATION]: {
    id: 'utils.exceptions.api.messages.USER_ACTIVATION_TOKEN_VALIDATION',
    description: 'Default message for api error USER_ACTIVATION_TOKEN_VALIDATION',
    defaultMessage:
      `La verificación de usuario ha fallado. Por favor asegúrate que la url introducida es
       tal como aparece en el correo electrónico o prueba a iniciar sesión con tu usuario.`
  },
  // Hacienda
  [codes.HACIENDA_BAD_REQUEST]: {
    id: 'utils.exceptions.api.messages.HACIENDA_BAD_REQUEST',
    description: 'Default message for api error HACIENDA_BAD_REQUEST',
    defaultMessage:
      `Lo sentimos, no hemos podido descargar tu documento de Hacienda,
       por favor asegúrate que el código introducido es correcto.`
  },
  [codes.HACIENDA_BLOCKED_REQUEST]: {
    id: 'utils.exceptions.api.messages.HACIENDA_BLOCKED_REQUEST',
    description: 'Default message for api error HACIENDA_BLOCKED_REQUEST',
    defaultMessage:
      `Lo sentimos, no hemos podido comunicarnos con Hacienda,
       por favor intentelo de nuevo mañana.`
  },
  [codes.HACIENDA_READ_PDF_ERROR]: {
    id: 'utils.exceptions.api.messages.HACIENDA_READ_PDF_ERROR',
    description: 'Default message for api error HACIENDA_READ_PDF_ERROR',
    defaultMessage:
      `Lo sentimos, no hemos podido descargar tu documento de Hacienda,
      por favor asegúrate que el código introducido es correcto.`
  },
  [codes.HACIENDA_VALIDATION_ERROR]: {
    id: 'utils.exceptions.api.messages.HACIENDA_VALIDATION_ERROR',
    description: 'Default message for api error HACIENDA_VALIDATION_ERROR',
    defaultMessage: 'No corresponde'
  },
  [codes.HACIENDA_VALIDATION_ERROR_NIF]: {
    id: 'utils.exceptions.api.messages.HACIENDA_VALIDATION_ERROR_NIF',
    description: 'Default message for api error HACIENDA_VALIDATION_ERROR_NIF',
    defaultMessage: 'Lo sentimos el NIF que aparece en el documento no corresponde con el nif de la organización de la solicitud'
  },
  [codes.HACIENDA_VALIDATION_ERROR_MODEL]: {
    id: 'utils.exceptions.api.messages.HACIENDA_VALIDATION_ERROR_MODEL',
    description: 'Default message for api error HACIENDA_VALIDATION_ERROR_MODEL',
    defaultMessage: 'Lo sentimos el modelo del documento no coincide con el código de verificación'
  },
  [codes.HACIENDA_VALIDATION_ERROR_PERIOD]: {
    id: 'utils.exceptions.api.messages.HACIENDA_VALIDATION_ERROR_PERIOD',
    description: 'Default message for api error HACIENDA_VALIDATION_ERROR_PERIOD',
    defaultMessage: 'Lo sentimos el ejercicio / periodo del documento no corresponde con el solicitado'
  },
  // Not implemented errors
  [codes.DATABASE_ERROR]: {
    id: 'utils.exceptions.api.messages.DATABASE_ERROR',
    description: 'Default message for api error DATABASE_ERROR',
    defaultMessage:
      `Lo sentimos ha ocurrido un error desconocido en el servidor.
      Por favor intentelo de nuevo más tarde.
      Si el problema persiste no dudes en contactar con nosotros.`
  },
  [codes.NOT_IMPLEMENTED_ERROR]: {
    id: 'utils.exceptions.api.messages.NOT_IMPLEMENTED_ERROR',
    description: 'Default message for api error NOT_IMPLEMENTED_ERROR',
    defaultMessage:
      `Lo sentimos ha ocurrido un error desconocido en el servidor.
      Por favor intentelo de nuevo más tarde.
      Si el problema persiste no dudes en contactar con nosotros.`
  },
  // Internal Codes
  [internalCodes.REQUEST_NOT_FOUND]: {
    id: 'utils.exceptions.messages.REQUEST_NOT_FOUND',
    description: 'Default message for api error REQUEST_NOT_FOUND',
    defaultMessage:
      `Lo solicitud que buscas no existe o se ha borrado.`
  },
  [internalCodes.DOCUMENT_ALREADY_UPLOADED]: {
    id: 'utils.exceptions.messages.DOCUMENT_ALREADY_UPLOADED',
    description: 'Default message for api error DOCUMENT_ALREADY_UPLOADED',
    defaultMessage:
      `Lo sentimos, el modelo facilitado ya lo has subido previamente.`
  },
  [internalCodes.USER_NOT_BELONGS_TO_REQUEST]: {
    id: 'utils.exceptions.messages.USER_NOT_BELONGS_TO_REQUEST',
    description: 'Default message for api error USER_NOT_BELONGS_TO_REQUEST',
    defaultMessage:
      `No tienes permisos para ver esta solicitud.`
  },
  [internalCodes.INVALID_MIME_TYPE]: {
    id: 'utils.exceptions.messages.INVALID_MIME_TYPE',
    description: 'Default message for api error INVALID_MIME_TYPE',
    defaultMessage:
      'Por favor selecciona un fichero en uno de los siguientes formatos: pdf, word o excel'
  },
  [internalCodes.DOCUMENTS_CHECK_FAILING]: {
    id: 'utils.exceptions.messages.DOCUMENTS_CHECK_FAILING',
    description: 'Default message for api error DOCUMENTS_CHECK_FAILING',
    defaultMessage: 'Lo sentimos, faltan documentos obligatorios por subir. Por favor, revisa el formulario.'
  },
  [internalCodes.HACIENDA_PARSING_ERROR]: {
    id: 'utils.exceptions.api.messages.HACIENDA_PARSING_ERROR',
    description: 'Default message for api error HACIENDA_PARSING_ERROR',
    defaultMessage: 'Lo sentimos no podemos validar el modelo del documento con el código de verificación, por favor, adjunte su declaración original de la AEAT.'
  }
})
